<script>
export default {
  props: {
    characterId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    fukidashi: '',
    intervalId: null
  }),
  computed: {
    mainList () {
      if (this.$route.meta.version === 'raz') {
        return this.docs.razcharacter.index.main
      } else {
        return this.docs.character.index.main
      }
    },
    caseList () {
      if (this.$route.meta.version === 'raz') {
        return this.docs.razcharacter.index.case
      } else {
        return this.docs.character.index.case
      }
    },
    character () {
      if (this.$route.meta.version === 'raz') {
        return this.docs.razcharacter[this.characterId]
      } else {
        return this.docs.character[this.characterId]
      }
    }
  },
  watch: {
    'character.fukidashi': {
      immediate: true,
      handler () {
        this.fukidashi = ''
        clearInterval(this.intervalId)
        if (!this.character.fukidashi) {
          return
        }
        let i = 0
        setTimeout(() => {
          this.intervalId = setInterval(() => {
            if (this.character.fukidashi[i - 1] === '<') {
              // HTMLタグをスキップ
              i += 3
            }
            this.fukidashi = this.character.fukidashi.substring(0, i)
            i++
            if (this.character.fukidashi.length < i) {
              clearInterval(this.intervalId)
            }
          }, 1000 / 15)
        }, 1000 / 4)
      }
    }
  },
  destroyed () {
    clearInterval(this.intervalId)
  },
  methods: {
    beforeEnter () {
      this.$refs.nav.classList.add('is-hidden-mobile')
    },
    afterEnter () {
      this.$refs.nav.classList.remove('is-hidden-mobile')
    }
  }
}
</script>

<template>
  <div
    class="gp-character"
    :class="{ raz: $route.meta.version === 'raz' }"
  >
    <div class="page-background"></div>
    <header>
      <h1 class="page-title">CHARACTER</h1>
    </header>

    <div
      class="tab level-center is-mobile"
      :class="{ 'has-long-fukidashi': ['lin', 'sai'].includes(characterId) }"
    >
      <router-link :to="{ name: 'character', params: { characterId: 'edamame' } }">
        <h2
          class="gp level-center is-mobile"
          :class="{ current: !$route.meta.version }"
        >
          <img src="/assets/images/logo-gp-kana.svg" />
        </h2>
      </router-link>

      <router-link :to="{ name: 'raz-character', params: { characterId: 'dorothy' } }">
        <h2
          class="raz level-center is-mobile"
          :class="{ current: $route.meta.version === 'raz' }"
        >
          <img src="/assets/images/logo-gp-kana-raz.svg" />
        </h2>
      </router-link>
    </div>

    <div class="transition-container">
      <div class="transition-item">
        <div>
          <transition
            name="slide-in"
            v-on:before-enter="beforeEnter"
            v-on:after-enter="afterEnter"
          >
            <article
              class="character"
              :key="characterId"
              :class="[
                characterId === 'laurent' ? 'laurent' : '',
                character.type,
              ]"
            >
              <div
                v-if="$route.meta.version === 'raz'"
                class="raz-fukidashi"
              >
                <div class="fukidashi has-text-weight-bold">
                  <span v-html="fukidashi"></span>
                </div>
              </div>

              <header class="has-text-weight-bold">
                <div
                  v-if="$route.meta.version !== 'raz'"
                  class="fukidashi omit-yakuhan"
                >
                  <span v-html="fukidashi"></span>
                </div>
                <h1>
                  <span class="character-name">{{ character.name }}</span>
                  <span
                    class="is-size-1 is-size-2-mobile"
                    v-if="character.kana"
                  >（{{ character.kana }}）</span>
                </h1>
                <div class="cv is-size-3 is-size-5-mobile">cv.{{ character.cv }}</div>
              </header>

              <figure
                class="image"
                :style="'background-image: url(' + character.image + ')'"
              >
              </figure>
              <div class="description is-size-5 is-size-6-mobile">
                <p v-html="character.description"></p>
              </div>
              <div class="en-name has-text-align-center is-family-oswald">{{ character.en }}</div>
            </article>
          </transition>

          <nav ref="nav">
            <div class="main">
              <ul>
                <li
                  class="icon"
                  v-for="character in mainList"
                  :key="character.id"
                  :class="{current: characterId === character.id}"
                >
                  <router-link :to="{ name: $route.meta.version === 'raz' ? 'raz-character': 'character', 'params': {characterId: character.id} }">
                    <figure
                      class="image cover"
                      :style="'background-image: url(' + character.icon + ')'"
                    ></figure>
                  </router-link>
                </li>
              </ul>
            </div>

            <div
              class="case"
              v-for="caseItem in caseList"
              :key="caseItem.case"
            >
              <p class="is-size-2 is-size-4-mobile is-family-oswald has-text-weight-bold">{{ caseItem.case }}</p>
              <ul>
                <li
                  class="icon"
                  v-for="character in caseItem.character"
                  :key="character.id"
                  :class="{current: characterId === character.id}"
                >
                  <router-link :to="{name: 'character', 'params': {characterId: character.id}}">
                    <figure
                      class="image cover"
                      :style="'background-image: url(' + character.icon + ')'"
                    ></figure>
                  </router-link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gp-character {
  @include is-not-mobile {
    min-width: 50rem;
    min-height: 55rem !important;
    padding-bottom: 15rem !important;
    .page-title {
      margin-bottom: 4rem;
    }
  }

  .transition-container {
    @include is-not-mobile {
      min-width: 50rem;
    }
  }
  .transition-item > div {
    @include is-not-mobile {
      min-width: 55rem;
      width: 100%;
      padding: 0 3rem;
      position: relative;
    }
  }
  article.character {
    color: $white;
    background-color: $black-transparent;
    @include is-not-mobile {
      position: relative;
      width: 43rem;
      padding: 1.5rem 2rem;
    }
    .cv {
      margin-top: .5rem;
    }
    .en-name {
      position: absolute;
      transform: rotateZ(270deg);
      opacity: .5;
    }
    &.main {
      @include is-not-mobile {
        height: 29rem;
        padding-top: 7rem;
        padding-right: 20rem;
      }
      header {
        margin-bottom: 3rem;
        @include is-mobile {
          margin-bottom: -2.5rem;
        }
      }
      figure {
        @include is-mobile {
          width: 12.5rem;
          height: 35rem;
          background-size: contain;
          background-repeat: no-repeat;
          margin: auto;
          margin-bottom: -1.5rem;
        }
        @include is-not-mobile {
          position: absolute;
          z-index: 1;
          right: 3.5rem;
          top: -7.5rem;
          width: 18rem;
          height: 50rem;
        }
      }
    }
    &.sub {
      @include is-mobile {
        padding: 2rem 1.5rem;
      }
      @include is-not-mobile {
        display: flex;
        flex-direction: column;
        figure { order: 1; }
        header { order: 2; }
        .description { order: 3; }
      }
      @include is-not-mobile {
        header {
          margin: 1rem 0 .5rem;
        }
      }
      figure {
        @include is-mobile {
          width: 100%;
          aspect-ratio: 16 / 9;
          background-size: contain;
          background-repeat: no-repeat;
          margin: 1rem auto 1.5rem;
        }
        @include is-not-mobile {
          width: 100%;
          height: 20rem;
        }
      }
    }
  }

  nav {
    z-index: 1;
    @include is-not-mobile {
      position: absolute;
      right: 0;
      top: -5.5rem;
      max-width: 12.5rem;
    }
    ul {
      @include is-mobile {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
      }
    }
    li.icon {
      &:hover:not(.current) {
        animation: medium-expansion .2s 0s ease-out forwards;
      }
      a {
        overflow: hidden;
        display: block;
      }
    }
    .main {
      @include is-mobile {
        margin: 1rem;
      }
      @include is-not-mobile {
        margin-bottom: 3rem;
        width: 12.5rem;
      }
      li.icon {
        margin-right: .5rem;
        margin-bottom: .5rem;
        @include is-not-mobile {
          display: inline-block;
          &:nth-child(even) {
            position: relative;
            top: 3rem;
          }
        }
        a {
          border-radius: 10rem;
          @include is-mobile {
            border: solid 4px transparent;
          }
          @include is-not-mobile {
            border: solid 6px transparent;
          }
        }
        figure {
          @include is-mobile {
            width: 4.25rem;
            height: 4.25rem;
          }
          @include is-not-mobile {
            width: 5rem;
            height: 5rem;
          }
        }
        &.current {
          a {
            background-color: $black;
            border: solid 6px $green;
            cursor: default;
            @include is-mobile {
              border: solid 4px $green;
            }
          }
          figure {
            opacity: .75;
          }
        }
      }
    }
    .case {
      color: $white;
      @include is-mobile {
        margin: .5rem 1.5rem;
      }
      @include is-not-mobile {
        margin-bottom: 1rem;
        width: calc(100vw / 2 - 27.5rem);
        min-width: 12.5rem;
      }
      p {
        margin-bottom: .25rem;
      }
      ul {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        li.icon {
          @include is-mobile {
            &:not(:last-child){
              margin-right: .5rem;
            }
          }
          @include is-not-mobile {
            margin-right: 2px;
          }
          a {
            border: solid 3px transparent;
          }
          figure {
            width: 3rem;
            height: 3rem;
          }
          &.current {
            a {
              background-color: $black;
              border: solid 3px $green;
              cursor: default;
            }
            figure {
              opacity: .75;
            }
          }
        }
      }
    }
  }

  @include is-mobile {
    .page-title {
      margin-bottom: 3rem;
    }
    article.character {
      padding: 2.25rem 1.5rem 2rem;
      position: relative;
      margin: 0 1rem;
      header {
        .character-name {
          font-size: 1.875rem;
          line-height: 2.125rem;
        }
        .en-name {
          width: 29rem;
          right: -189px;
          top: 184px;
          font-size: 6rem;
          line-height: 6rem;
        }
      }
      .description {
        line-height: 1.25rem;
      }
    }
    .en-name {
      width: 29rem;
      right: -196px;
      top: 300px;
      font-size: 5rem;
      line-height: 5rem;
    }
    nav {
    }
  }
  @include is-not-mobile {
    article.character {
      .character-name {
        font-size: 2.5rem;
        line-height: 2.75rem;
      }
      .description {
        line-height: 1.5rem;
      }
      .en-name {
        width: 29rem;
        right: -189px;
        top: 184px;
        font-size: 6rem;
        line-height: 6rem;
      }
      &.laurent {
        figure {
          right: 0rem;
        }
      }
    }
  }
}

.fukidashi {
  position: absolute;
  span {
    color: $black;
    background-color: $green;
  }

  @include is-mobile {
    top: -3.5rem;
    left: 0;
    font-size: 1.75rem;
    line-height: 35px;
  }

  @include is-not-mobile {
    top: -2rem;
    font-size: 2.5rem;
    line-height: 50px;
  }
}

.tab {
  align-items: flex-start !important;

  @include is-mobile {
    height: 3rem;
    gap: .75rem;
    margin-bottom: 4rem;
  }

  @include is-not-mobile {
    height: 4.5rem;
    gap: 2.5rem;
    margin-bottom: 6rem;
  }

  h2 {
    padding-bottom: 0;
    transition: padding-bottom .06s ease, opacity .06s linear;
    opacity: .7;

    @include is-mobile {
      height: 2rem;
      width: 10.25rem;
    }

    @include is-not-mobile {
      height: 3rem;
      width: 17rem;
    }

    &.current {
      opacity: 1;
    }
  }

  h2.gp {
    background-color: #B20C1A;

    img {
      @include is-mobile {
        width: 8rem;
      }
    }
  }

  h2.raz {
    background-color: #FFF;

    img {
      @include is-mobile {
        width: 9.5rem;
      }
    }
  }
}

.raz-fukidashi {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  .fukidashi {
    left: 0;
    top: auto !important;

    @include is-mobile {
      bottom: .1875rem;
    }
    @include is-not-mobile {
      bottom: .25rem;
    }
  }
}

.tab.has-long-fukidashi {
  @include is-mobile {
    margin-bottom: 7rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/character.vue